import React, { useState } from "react";
import { UploadZone, DownloadButton, ResetButton, humanBytes, loadImage } from "./_shared";

export default function FormatConverter({ from, to }) {
  const [file, setFile] = useState(null);
  const [outUrl, setOutUrl] = useState(null);
  const [outSize, setOutSize] = useState(0);
  const mime = `image/${to}`;
  const label = { jpeg: "JPG", png: "PNG", webp: "WebP" };

  const handleFile = async (f) => {
    setFile(f);
    const { img } = await loadImage(f);
    const canvas = document.createElement("canvas");
    canvas.width = img.naturalWidth; canvas.height = img.naturalHeight;
    if (to === "jpeg") { const ctx = canvas.getContext("2d"); ctx.fillStyle = "#fff"; ctx.fillRect(0, 0, canvas.width, canvas.height); ctx.drawImage(img, 0, 0); }
    else canvas.getContext("2d").drawImage(img, 0, 0);
    canvas.toBlob((blob) => {
      if (outUrl) URL.revokeObjectURL(outUrl);
      setOutUrl(URL.createObjectURL(blob)); setOutSize(blob.size);
    }, mime, 0.92);
  };

  const reset = () => { setFile(null); setOutUrl(null); setOutSize(0); };

  if (!file) return <UploadZone onFile={handleFile} accept={`image/${from}`} hint={`Upload ${label[from]} — will convert to ${label[to]}`} />;
  return (
    <div className="space-y-6">
      <div className="rounded-2xl border border-slate-200 dark:border-white/10 overflow-hidden bg-slate-50 dark:bg-[#0b0c0e] p-4">
        {outUrl && <img src={outUrl} alt="out" className="w-full max-h-96 object-contain" />}
      </div>
      <div className="rounded-xl border border-slate-200 dark:border-white/10 p-4 flex items-center justify-between text-sm">
        <div>
          <span className="text-slate-500 dark:text-slate-400">Converted to </span>
          <span className="font-semibold text-slate-900 dark:text-white">{label[to]}</span>
          <span className="ml-4 text-slate-500 dark:text-slate-400">{humanBytes(outSize)}</span>
        </div>
      </div>
      <div className="flex items-center gap-3">
        <DownloadButton href={outUrl} filename={`${file.name.replace(/\.[^.]+$/, "")}.${to === "jpeg" ? "jpg" : to}`}>
          Download {label[to]}
        </DownloadButton>
        <ResetButton onClick={reset} />
      </div>
    </div>
  );
}
